import { NotificationType } from '@baserow/modules/core/notificationTypes'
import NotificationSenderInitialsIcon from '@baserow/modules/core/components/notifications/NotificationSenderInitialsIcon'
import CollaboratorAddedToRowNotification from '@baserow/modules/database/components/notifications/CollaboratorAddedToRowNotification'
import UserMentionInRichTextFieldNotification from '@baserow/modules/database/components/notifications/UserMentionInRichTextFieldNotification'
import FormSubmittedNotification from '@baserow/modules/database/components/notifications/FormSubmittedNotification'
import WebhookDeactivatedNotification from '@baserow/modules/database/components/notifications/WebhookDeactivatedNotification'
import WebhookPayloadTooLargeNotification from '@baserow/modules/database/components/notifications/WebhookPayloadTooLargeNotification'
import RowApprovalDecisionNotification from '@baserow/modules/database/components/notifications/RowApprovalDecisionNotification'
import RowChecklistCompletedNotification from '@baserow/modules/database/components/notifications/RowChecklistCompletedNotification'
import ClientRatingReceivedNotification from '@baserow/modules/database/components/notifications/ClientRatingReceivedNotification'
import ConversationProposedNotification from '@baserow/modules/database/components/notifications/ConversationProposedNotification'
import ConversationTranscribedNotification from '@baserow/modules/database/components/notifications/ConversationTranscribedNotification'
import KudosReceivedNotification from '@baserow/modules/database/components/notifications/KudosReceivedNotification'
import { tableRouteResetViewIfNeeded } from '@baserow/modules/database/utils/routing'

export class CollaboratorAddedToRowNotificationType extends NotificationType {
  static getType() {
    return 'collaborator_added_to_row'
  }

  getIconComponent() {
    return NotificationSenderInitialsIcon
  }

  getContentComponent() {
    return CollaboratorAddedToRowNotification
  }

  getRoute(notificationData) {
    return tableRouteResetViewIfNeeded(this.app.$router, {
      databaseId: notificationData.database_id,
      tableId: notificationData.table_id,
      rowId: notificationData.row_id,
    })
  }
}

export class FormSubmittedNotificationType extends NotificationType {
  static getType() {
    return 'form_submitted'
  }

  getIconComponent() {
    return null
  }

  getContentComponent() {
    return FormSubmittedNotification
  }

  getRoute(notificationData) {
    return tableRouteResetViewIfNeeded(this.app.$router, {
      databaseId: notificationData.database_id,
      tableId: notificationData.table_id,
      rowId: notificationData.row_id,
    })
  }
}

export class UserMentionInRichTextFieldNotificationType extends NotificationType {
  static getType() {
    return 'user_mention_in_rich_text_field'
  }

  getIconComponent() {
    return NotificationSenderInitialsIcon
  }

  getContentComponent() {
    return UserMentionInRichTextFieldNotification
  }

  getRoute(notificationData) {
    return tableRouteResetViewIfNeeded(this.app.$router, {
      databaseId: notificationData.database_id,
      tableId: notificationData.table_id,
      rowId: notificationData.row_id,
    })
  }
}

export class WebhookDeactivatedNotificationType extends NotificationType {
  static getType() {
    return 'webhook_deactivated'
  }

  getIconComponent() {
    return null
  }

  getContentComponent() {
    return WebhookDeactivatedNotification
  }

  getRoute(notificationData) {
    return tableRouteResetViewIfNeeded(
      this.app.$router,
      {
        databaseId: notificationData.database_id,
        tableId: notificationData.table_id,
      },
      'database-table-open-webhooks'
    )
  }
}

export class WebhookPayloadTooLargedNotificationType extends NotificationType {
  static getType() {
    return 'webhook_payload_too_large'
  }

  getIconComponent() {
    return null
  }

  getContentComponent() {
    return WebhookPayloadTooLargeNotification
  }

  getRoute(notificationData) {
    return tableRouteResetViewIfNeeded(
      this.app.$router,
      {
        databaseId: notificationData.database_id,
        tableId: notificationData.table_id,
      },
      'database-table-open-webhooks'
    )
  }
}

// Origem Flow: o cliente decidiu (Aprovar / Pedir ajuste) numa página
// pública de aprovação — leva a equipe direto para a tarefa da peça.
export class RowApprovalDecisionNotificationType extends NotificationType {
  static getType() {
    return 'row_approval_decision'
  }

  getIconComponent() {
    return null
  }

  getContentComponent() {
    return RowApprovalDecisionNotification
  }

  getRoute(notificationData) {
    return tableRouteResetViewIfNeeded(this.app.$router, {
      databaseId: notificationData.database_id,
      tableId: notificationData.table_id,
      rowId: notificationData.row_id,
    })
  }
}

// Origem Flow: o cliente concluiu uma lista de pendências.
export class RowChecklistCompletedNotificationType extends NotificationType {
  static getType() {
    return 'row_checklist_completed'
  }

  getIconComponent() {
    return null
  }

  getContentComponent() {
    return RowChecklistCompletedNotification
  }

  getRoute(notificationData) {
    return tableRouteResetViewIfNeeded(this.app.$router, {
      databaseId: notificationData.database_id,
      tableId: notificationData.table_id,
      rowId: notificationData.row_id,
    })
  }
}

export class ClientRatingReceivedNotificationType extends NotificationType {
  static getType() {
    return 'client_rating_received'
  }

  getIconComponent() {
    return null
  }

  getContentComponent() {
    return ClientRatingReceivedNotification
  }

  getRoute(notificationData) {
    if (!notificationData.table_id) {
      return { name: 'dashboard' }
    }
    return tableRouteResetViewIfNeeded(this.app.$router, {
      databaseId: notificationData.database_id,
      tableId: notificationData.table_id,
      rowId: notificationData.row_id,
    })
  }
}

// Origem Flow (H3): a IA da assinatura propôs tarefas / transcrição pronta —
// o clique abre a tabela com o modal de revisão (?conversa=<id>).
function conversationRoute(app, data) {
  const route = tableRouteResetViewIfNeeded(app.$router, {
    databaseId: data.database_id,
    tableId: data.table_id,
  })
  return { ...route, query: { ...(route.query || {}), conversa: data.import_id } }
}

export class ConversationProposedNotificationType extends NotificationType {
  static getType() {
    return 'conversation_proposed'
  }

  getIconComponent() {
    return null
  }

  getContentComponent() {
    return ConversationProposedNotification
  }

  getRoute(notificationData) {
    return conversationRoute(this.app, notificationData)
  }
}

export class ConversationTranscribedNotificationType extends NotificationType {
  static getType() {
    return 'conversation_transcribed'
  }

  getIconComponent() {
    return null
  }

  getContentComponent() {
    return ConversationTranscribedNotification
  }

  getRoute(notificationData) {
    return conversationRoute(this.app, notificationData)
  }
}

// Origem Flow (H4): kudos recebido.
export class KudosReceivedNotificationType extends NotificationType {
  static getType() {
    return 'kudos_received'
  }

  getIconComponent() {
    return null
  }

  getContentComponent() {
    return KudosReceivedNotification
  }

  getRoute(notificationData) {
    if (!notificationData.table_id) {
      return { name: 'dashboard' }
    }
    return tableRouteResetViewIfNeeded(this.app.$router, {
      databaseId: notificationData.database_id,
      tableId: notificationData.table_id,
      rowId: notificationData.row_id,
    })
  }
}
